/*eslint-disable*/
import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import { Apps, CloudDownload } from "@material-ui/icons";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Link to="/" className={classes.navLink}>
          Faqja Kryesore
        </Link>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Link to="/rreth-nesh" className={classes.navLink}>
          Rreth Nesh
        </Link>
      </ListItem>

      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          hoverColor="black"
          buttonText="Produkte"
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          buttonIcon={Apps}
          dropdownList={[
            <Link to="/produkte/seria-m" className={classes.dropdownLink}>
              Seria M
            </Link>,
            <Link to="/produkte/seria-s" className={classes.dropdownLink}>
              Seria S
            </Link>,
            <Link to="/produkte/seria-p" className={classes.dropdownLink}>
              Seria P
            </Link>,

            <Link
              to="/produkte/seria-multisplit"
              className={classes.dropdownLink}
            >
              Seria Multi-Split
            </Link>
          ]}
        />
      </ListItem>

      <ListItem className={classes.listItem}>
        <Link to="/teknologjia-mitsubishi" className={classes.navLink}>
          Teknologjia Mitsubishi
        </Link>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Link to="/kontakt" className={classes.navLink}>
          Kontakt
        </Link>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-facebook"
          title="Na ndiqni në Facebook"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.facebook.com/plusklimaKondicionere"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-facebook"} />
          </Button>
        </Tooltip>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-facebook"
          title="Na ndiqni në Instagram"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.instagram.com/plus_klima"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-instagram"} />
          </Button>
        </Tooltip>
      </ListItem>
    </List>
  );
}
